module.exports = __webpack_public_path__ + "img/team-member-bg.0cf19d47.png";